import React from "react";
import { useDispatch } from "react-redux";
import { setToast } from "../../store/slices/toastSlice";
import { Box, Link, Button, IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import moment from "moment";

interface HandleInterviewLinkProps {
  link: string | null;
}

const HandleInterviewLink: React.FC<HandleInterviewLinkProps> = ({
  link,
}): JSX.Element => {
  const dispatch = useDispatch();

  const handleCopy = (link: string) => {
    navigator.clipboard.writeText(link);
    dispatch(
      setToast({
        message: "Link copied to clipboard",
        severity: "success",
        open: true,
      })
    );
  };

  return (
    <>
      {link ? (
        <Button
          sx={{
            padding: 0,
            minWidth: 0,
            height: "auto",
            display: "inline-flex",
            "&:hover": {
              padding: 0,
              background: "transparent",
            },
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            sx={{ padding: 0, margin: 0 }}
          >
            <Tooltip title="Click here to join the meeting" arrow>
              <Link
                href={link}
                target="_blank"
                rel="noopener"
                underline="none"
                sx={{
                  whiteSpace: "nowrap",
                  marginRight: "8px",
                  padding: 0,
                  textDecoration: "none",
                }}
              >
                Interview Link
              </Link>
            </Tooltip>
            <Tooltip
              title="Copy to clipboard"
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, 10],
                    },
                  },
                ],
              }}
            >
              <IconButton
                onClick={() => handleCopy(link)}
                aria-label="copy link"
                sx={{ padding: 0 ,height:'5px'}}
              >
                <ContentCopy
                  fontSize="small"
                  sx={{
                    width: "18px",
                    height: "18px",
                    padding: 0,
                    margin: 0,
                    lineHeight: "0",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Button>
      ) : (
        "NA"
      )}
    </>
  );
};

export default HandleInterviewLink;


export const handleDate=(date:string):string=>{
  if(!date){
    return "NA";
  }
  return moment(date).format('DD-MMM-YYYY');
}
